export default __webpack_public_path__ + "static/media/logo_white.d7730102.png";